import { colors } from '../../../shared/styles/baseStyle';

export const policyNumberFormItem = { marginTop: 15, marginBottom: 0 };
export const inputItem = { borderRadius: 8 };
export const termsItem = { marginTop: 0 };
export const remindPolicyNumberButton = {
  display: 'block',
  color: colors.anytimeBlue,
  padding: 4,
  height: 'auto',
  fontWeight: 'bold'
};
export const remindPolicyNumberRow = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: 8
};
export const checkBoxText = { fontSize: 11, fontWeight: 'bold' };
export const linkColor = { color: colors.anytimeBlue };
export const buttonItem = { marginTop: 60, marginBottom: 20 };
export const button = {
  color: 'white',
  border: 'none',
  borderRadius: 8,
  fontWeight: 600
};
